import React from "react"
import LoginForm from "components/organisms/LoginForm"

function LoginPage() {
  return (
    <LoginForm/>
  )
}

export default LoginPage
